export const Endpoint = () => `/api/v3/reports/vulndetail/`;
export const QueryKey = (payload: Payload | undefined) => ['v3', 'reports', 'vulndetail', payload].filter(Boolean);
export type Payload = {
    vulnid: string;
    scanid: string;
};

export type Response = {
    reason: {
        fix: string;
        cvelist: string[];
        providedOSName: string;
        providedOSVersion: string;
        providedPackage: string;
        bulletinOSVersion: string;
    };
    bulletin: {
        affectedPackage: {
            packageName: string;
            packageVersion: string;
            OSVersion: string;
        }[];
    };
};
